<template>
  <AhLink
    v-if="cardContent.src || cardContent.title || cardContent.desc"
    :id="cardContent.id"
    :url="cardContent.url"
    :target="target"
    :tracking="cardContent.tracking"
    class="ah-card-widget"
    @ah-link-clicked="handleClick"
  >
    <AhPicture
      v-if="cardContent.src"
      :src="cardContent.src"
      :alt="cardContent.alt"
      :is-media-pic="$imgFromDynamicMedia"
      :pictures-media="picturesMediaData"
    />

    <p
      v-if="cardContent.title"
      class="ah-card-widget__title"
      v-text="cardContent.title"
    />
    <!-- eslint-disable vue/no-v-html -->
    <div
      v-if="cardContent.desc"
      class="ah-card-widget__desc"
      v-html="cardContent.desc"
    />
  </AhLink>
</template>
<script>
  import AhPicture from '../../atoms/AhPicture/AhPicture.vue';
  import AhLink from '../../atoms/AhLink/AhLink.vue';

  export default {
    name: 'AhCardWidget',
    components: { AhPicture, AhLink },
    inject: {
      $imgFromDynamicMedia: {
        default: false,
      },
      $dynamicMediaParams: {
        default: false,
      }
    },
    props: {
      /**
       * @param {Object} cardContent           Props of the Card Widget
       * @param {String} cardContent.id        id of the card
       * @param {String} cardContent.url       url the link on the card
       * @param {String} cardContent.title     title of the card
       * @param {String} cardContent.desc      desc text of the card
       * @param {String} cardContent.src       src of the picture TODO:
       * @param {String} cardContent.alt       alt of the image
       * @param {String} cardContent.a11y      a11y of the card
       * @param {String} cardContent.tracking  tracking emmited by the Card Widget
       */
      cardContent: {
        type: Object,
        required: true,
        /* validator: (val) => {
          return (
            val.url &&
            val.src &&
            val.title &&
            val.desc
          );
        } */
      },
      target: {
        type: String,
        default: ''
      }
    },
    computed: {
      picturesMediaData() {
        return this.$dynamicMediaParams ? Object.values(this.$dynamicMediaParams['widget']) : null;
      }
    },
    methods: {
      handleClick (data) {
        this.$emit('clickWidget', {tracking:'', ...this.cardContent, ...data });
      }
    }
  };
</script>
